import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@utex/ui-kit';
import { MoneyView } from '../../../MoneyView';
import { Commission } from '../../../Commission';
import { Instrument } from '../../../../hooks/mapInstruments';

export const Info: React.FC<Instrument> = ({ minimum, currency, commission }) => {
  const { t } = useTranslation('withdraw');
  return (
    <Typography.Text size={{ all: 'M', phonablet: 'XS' }} view="hint">
      {t('Min')} <MoneyView>{minimum}</MoneyView>
      {'. '}
      {t('Commission')} <Commission commission={commission} />
    </Typography.Text>
  );
};
